function IndexTableMap({
  title,
  actionButtons,
  columns,
  rows,
  rowKey,
  search,
  onSearchChange,
  page,
  totalPages,
  onPrevPage,
  onNextPage,
  emptyText,
}) {
  return (
    <article className="panel table-panel">
      <div className="index-table-bar">
        <h2>{title}</h2>
        <div className="index-table-actions">
          {actionButtons.map((button) => (
            <button
              key={button.key}
              className={`button-link ${button.active ? "index-action-active" : ""}`}
              type="button"
              onClick={button.onClick}
            >
              {button.label}
            </button>
          ))}
        </div>
      </div>

      {/* <div className="index-table-search">
        <input
          className="field-input"
          placeholder="Buscar..."
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
        />
      </div> */}

      <div className="table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column.key}>{column.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={rowKey(row)}>
                {columns.map((column) => (
                  <td key={`${rowKey(row)}-${column.key}`}>
                    {column.render ? column.render(row) : row[column.key]}
                  </td>
                ))}
              </tr>
            ))}
            {!rows.length ? (
              <tr>
                <td colSpan={columns.length}>
                  {emptyText || "Sin resultados."}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>

      <div className="index-table-pagination">
        <button
          className="button-ghost"
          type="button"
          onClick={onPrevPage}
          disabled={page <= 1}
        >
          previous
        </button>
        <span>
          page {page} of {totalPages}
        </span>
        <button
          className="button-ghost"
          type="button"
          onClick={onNextPage}
          disabled={page >= totalPages}
        >
          next
        </button>
      </div>
    </article>
  );
}

export default IndexTableMap;
